// extracted by mini-css-extract-plugin
module.exports = {"container":"_1SXXeBJ6_GL_Io2crBWR4D"};